import { frontendURL } from '../../../../helper/URLHelper';
import { WHATSAPP_TEMPLATES_PERMISSIONS } from 'dashboard/constants/permissions.js';

import SettingsWrapper from '../SettingsWrapper.vue';

const TemplatesPage = () => import('./pages/TemplatesPage.vue');
const CreateTemplatePage = () => import('./pages/CreateTemplatePage.vue');
const EditTemplatePage = () => import('./pages/EditTemplatePage.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/whatsapp-official'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'whatsapp_official_wrapper',
          meta: {
            permissions: ['administrator', WHATSAPP_TEMPLATES_PERMISSIONS],
          },
          redirect: to => {
            return { name: 'whatsapp_templates_list', params: to.params };
          },
        },
        {
          path: 'templates',
          name: 'whatsapp_templates_list',
          meta: {
            permissions: ['administrator', WHATSAPP_TEMPLATES_PERMISSIONS],
          },
          component: TemplatesPage,
        },
        {
          path: 'templates/new',
          name: 'whatsapp_templates_create',
          meta: {
            permissions: ['administrator', WHATSAPP_TEMPLATES_PERMISSIONS],
          },
          component: CreateTemplatePage,
        },
        {
          path: 'templates/:templateId/edit',
          name: 'whatsapp_templates_edit',
          meta: {
            permissions: ['administrator', WHATSAPP_TEMPLATES_PERMISSIONS],
          },
          component: EditTemplatePage,
        },
      ],
    },
  ],
};
